export default __webpack_public_path__ + "static/media/product-tour4.7d8ee6c4.svg";